import leafLeftImg from '~/assets/leaf-l.svg'
import leafRightImg from '~/assets/leaf-r.svg'

export function Participant(props: { participantCountStr: string }) {
  return (
    <div class="flex items-center justify-center space-x-2">
      <div class="w-[34px]">
        <img src={leafLeftImg} />
      </div>
      <div>
        <div class="bg-[linear-gradient(133deg,_#31E8D9_12.71%,_#009387_74%)] bg-clip-text font-rubik text-[60px] font-bold text-transparent">
          {props.participantCountStr}
        </div>
      </div>
      <div class="w-[34px]">
        <img src={leafRightImg} />
      </div>
    </div>
  )
}
